/**
 * @author gll
 * 功能：单位模块
 */
import { Service } from '@/tools'
export class UnitService<T extends TCommodity.Unit> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TCommodity.Unit}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  // 单位下拉搜索
  unitList = <K extends T['ApiUnitList']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiUnitList', data)

  // 单位下拉搜索带辅助单位的  /api/commodity/unit/v1/queryUnitBySkuCode
  queryUnitBySkuCode = <K extends T['ApiQueryUnitBySkuCode']>(data?: K['req']): Promise<K['res']['data']> =>
    this.post2('v1/ApiQueryUnitBySkuCode', data)
  // unitPage
  //单位列表
  // /api/commodity/unit/v1/page
  page = <K extends T['ApiPage']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiPage', data)

  // unitAdd
  //新增单位
  // /api/commodity/unit/v1/add
  add = <K extends T['ApiAdd']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAdd', data, '添加成功')

  // unitUpdate
  //修改单位
  // /api/commodity/unit/v1/Update
  update = <K extends T['ApiUpdate']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdate', data, '更新成功')

  // unitEnable
  //启用单位
  // /api/commodity/unit/v1/enable
  enable = <K extends T['ApiEnable']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiEnable', data, '启用成功')

  // unitDisable
  //禁用单位
  // /api/commodity/unit/v1/disable
  disable = <K extends T['ApiDisable']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDisable', data, '禁用成功')

  // unitDelete
  //删除单位
  // /api/commodity/unit/v1/delete
  delete = <K extends T['ApiDelete']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDelete', data, '操作成功')
}
